import React from "react";

const CHIP = {
  PASS: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30",
  FAIL: "bg-red-500/10 text-red-400 border-red-500/30",
  PENDING: "bg-amber-500/10 text-amber-400 border-amber-500/30",
  "NOT VERIFIED": "bg-zinc-500/10 text-zinc-400 border-zinc-500/30 border-dashed",
};

export const StateChip = ({ state, testId }) => (
  <span data-testid={testId}
    className={`inline-flex items-center px-2 py-0.5 rounded-sm border text-[10px] font-mono font-semibold tracking-wider whitespace-nowrap ${CHIP[state] || CHIP["NOT VERIFIED"]}`}>
    {state}
  </span>
);

export const Field = ({ label, value, mono, testId, muted }) => (
  <div className="flex flex-col sm:flex-row sm:items-baseline gap-0.5 sm:gap-4 py-2 border-b border-[var(--border)] last:border-0">
    <div className="overline sm:w-56 shrink-0">{label}</div>
    <div data-testid={testId}
      className={`text-sm break-all ${mono ? "font-mono" : ""} ${muted ? "text-zinc-500 italic" : "text-white"}`}>
      {value}
    </div>
  </div>
);

export const Panel = ({ title, subtitle, children, testId, tone }) => (
  <section data-testid={testId}
    className={`tactical-card p-5 sm:p-6 ${tone === "danger" ? "border-red-500/40" : ""}`}>
    {title && <h2 className="font-display text-base font-semibold text-white">{title}</h2>}
    {subtitle && <p className="text-xs text-zinc-500 mt-1 mb-3">{subtitle}</p>}
    <div className={title ? "mt-3" : ""}>{children}</div>
  </section>
);
